import { api } from '../api/client'
import type { AuthUser, AuthSuccessResponse, LoginCredentials, RegisterCredentials } from './types'

export function getMe(): Promise<AuthUser> {
  return api.get<AuthUser>('/auth/me')
}

export function login(credentials: LoginCredentials): Promise<AuthSuccessResponse> {
  return api.post<AuthSuccessResponse>('/auth/login', credentials)
}

export function register(credentials: RegisterCredentials): Promise<AuthSuccessResponse> {
  return api.post<AuthSuccessResponse>('/auth/register', credentials)
}

export function refresh(): Promise<void> {
  return api.post<void>('/auth/refresh')
}

export function logout(): Promise<void> {
  return api.post<void>('/auth/logout')
}

export function googleSignIn(idToken: string): Promise<AuthSuccessResponse> {
  return api.post<AuthSuccessResponse>('/auth/google/signin', { idToken })
}

export function verifyEmail(token: string, email: string): Promise<{ success: boolean }> {
  return api.post<{ success: boolean }>('/auth/verify-email', { email, token })
}

export function resendVerification(email: string): Promise<void> {
  return api.post<void>('/auth/resend-verification', { email })
}

export function appleSignIn(identityToken: string, fullName: string | null): Promise<AuthSuccessResponse> {
  const parts = (fullName ?? '').split(' ')
  const firstName = parts[0] || null
  const lastName = parts.slice(1).join(' ') || null
  return api.post<AuthSuccessResponse>('/auth/apple', { identityToken, firstName, lastName })
}

export function forgotPassword(email: string): Promise<void> {
  return api.post<void>('/auth/password/forgot', { email })
}

export function resetPassword(email: string, token: string, newPassword: string): Promise<{ success: boolean }> {
  return api.post<{ success: boolean }>('/auth/password/reset', { email, token, newPassword })
}

export function getMyLimits(): Promise<{ maxParties: number; maxPartyMembers: number; maxPartyWorks: number }> {
  return api.get('/auth/me/limits')
}

export function updateCarousel(showCarousel: boolean): Promise<void> {
  return api.patch<void>('/auth/me/carousel', { showCarousel })
}

export function dismissHint(hintKey: string): Promise<void> {
  return api.post<void>('/auth/me/hints/dismiss', { hintKey })
}

export function resetHints(): Promise<void> {
  return api.post<void>('/auth/me/hints/reset')
}

